import { BaseProfileFetcher } from './base-profile-fetcher';
import { UserProfile } from '../providers/interfaces/profile-fetcher.interface';

export class GoogleProfileFetcher extends BaseProfileFetcher {
  constructor() {
    super('https://www.googleapis.com/oauth2/v2/userinfo');
  }

  mapToUserProfile(rawData: any): UserProfile {
    return {
      email: rawData.email,
      name: rawData.name,
      id: rawData.id,
      avatar: rawData.picture,
      username: rawData.email,
      raw: rawData,
    };
  }
}
